import axios from "axios";
import { API_BASE_URL_SERVICE } from "constant";
import authHeader from "./auth-header";

const insertServiceMunicipal = (values) => {
  return axios.post(API_BASE_URL_SERVICE + "services/insert", values, {
    headers: authHeader(),
  });
};

const getAllServiceMunicipal = () => {
  return axios.get(API_BASE_URL_SERVICE + "services/public/getAll", {
    headers: authHeader(),
  });
};

const deleteServiceMunicipal = (id) => {
  return axios.delete(API_BASE_URL_SERVICE + "services/delete?id=" + id, {
    headers: authHeader(),
  });
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  insertServiceMunicipal,
  getAllServiceMunicipal,
  deleteServiceMunicipal,
};
